export const preventKeyPress = (e: React.KeyboardEvent) => {
  const nonDigit = RegExp(/\D/)
  if (nonDigit.test(e.key)) {
    e.preventDefault()
  }
}
